export default __webpack_public_path__ + "static/media/search.700a958d.svg";